import { Component, input } from '@angular/core';

import { DeviceLockFingerprint, prettifyDeviceLockFingerprint } from '../../../services/device/device.utils';
import { faUserSecret } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'pace-core-device-lock-info',
    imports: [FontAwesomeModule],
    templateUrl: './device-lock-info.component.html',
    styleUrl: './device-lock-info.component.css',
})
export class DeviceLockInfoComponent {
    public fingerprint = input.required<DeviceLockFingerprint>();

    public faIncognito = faUserSecret;

    public prettifyFingerprint(fingerprint: DeviceLockFingerprint): string {
        if (fingerprint) {
            return prettifyDeviceLockFingerprint(fingerprint);
        }
        return 'unknown device';
    }
}
